import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import follow from './body';
import { useState, useEffect } from 'react';
import axios from 'axios';


const links = {

  ORCID: {
    title: "ORCID",
    link: 'https://orcid.org/0009-0005-6333-4299',
    desc: '0009-0005-6333-4299'
  },

  Instagram: {
    title: "Instagram",
    link: 'https://www.instagram.com/sushant_naik_official/',
    desc: '@sushant_naik_official'
  },

  YouTube: {
    title: "YouTube",
    link: 'https://www.youtube.com/@sushant_naik_official',
    desc: '@sushant_naik_official'
  },

  Hipi: {
    title: "Hipi",
    link: 'https://www.hipi.co.in/@sushant_naik_official',
    desc: '@sushant_naik_official'
  },
  Discord: {
    title: "Discord",
    link: 'https://discord.gg/sN2CFYZE',
    desc: 'Join our Discord Server'
  },

  Facebook: {
    title: "Facebook",
    link: 'https://www.facebook.com/sushantnaikoffical/',
    desc: '@sushant_naik_official'
  },

  X: {
    title: "X",
    link: 'https://x.com/sushant_naik_',
    desc: '@sushant_naik_'
  },

  GitHub: {
    title: "GitHub",
    link: 'https://github.com/sushantmnaik',
    desc: '@sushantmnaik'
  },

  Linkedin: {
    title: "Linkedin",
    link: 'http://www.linkedin.com/in/sushant-naik-42a48b390',
    desc: 'Sushant Naik'
  },

  PicsArt: {
    title: "PicsArt",
    link: 'https://picsart.com/u/sushantnaikofficial',
    desc: '@sushantnaikofficial'
  },

  Telegram: {
    title: "Telegram",
    link: 'https://t.me/sushant_naik_official',
    desc: '@sushant_naik_official'
  },

  WhatsApp: {
    title: "WhatsApp",
    link: 'https://whatsapp.com/channel/0029Va5wicVAO7RESSBVUU3A',
    desc: 'WhatsApp Channel'
  },

  Bsky: {
    title: "Bsky",
    link: 'https://bsky.app/profile/sushantnaik.bsky.social',
    desc: '@sushantnaik.bsky.social'
  },
  Email: {
    title: "Email",
    link: 'mailto:sushantmnaik2008@gmail.com',
    desc: 'sushantmnaik2008@gmail.com'
  }


}

const ins = links.Instagram
const yt = links.YouTube
const em = links.Email


const id = process.env.fireid
const api = process.env.fireapi

const Show = () => {


  const [subscriberCount, setSubscriberCount] = useState(0);

  useEffect(() => {
    const fetchSubscriberCount = async () => {
      try {
        const response = await axios.get(
          'https://www.googleapis.com/youtube/v3/channels',
          {
            params: {
              part: 'statistics',
              id: id,
              key: api,
            },
          }
        );
        const { subscriberCount } = response.data.items[0].statistics;
        setSubscriberCount(subscriberCount);
      } catch (error) {
        console.error('Error fetching subscriber count:', error);
      }
    };

    // Fetch subscriber count initially
    fetchSubscriberCount();

    // Refresh subscriber count every 60 seconds
    const interval = setInterval(fetchSubscriberCount, 60000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);
  // console.log(links.Email)

  return (
    <>
      {/* insta */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>
          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
            <defs> <linearGradient id="instaGradient" x1="0%" y1="0%" x2="100%" y2="100%"> <stop offset="0%" stopColor="#FF0050" /> <stop offset="100%" stopColor="#7B61FF" /> </linearGradient> </defs>
            <path fill="url(#instaGradient)" d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
          </svg>
          {ins.title}
        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {ins.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-info text-light" onClick={() => follow(
            ins.link, ins.title, 'Follow'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Follow
          </Button>
        </Card.Text>
      </Card>


      {/* yt */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>
          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-youtube" viewBox="0 0 16 16">
            <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
          </svg>

          {yt.title}
        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {yt.desc}
          <br />
          with {subscriberCount} Subscribers
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-danger text-light" onClick={() => follow(
            yt.link, yt.title, 'Subscribe'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Subscribe
          </Button>
        </Card.Text>
      </Card>


      {/* Email */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>
          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-at" viewBox="0 0 16 16">
            <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z" />
            <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
          </svg>
          {em.title}
        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {em.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-success text-light" onClick={() => follow(
            em.link, em.title, 'mail'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Email
          </Button>
        </Card.Text>
      </Card>





      {/* X */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M12.6 0H15l-5.2 5.94L16 16h-4.8L7.2 10.8 2.7 16H0l5.6-6.4L0 0h4.9l3.6 4.8z" />
          </svg>

          {links.X.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.X.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-light" onClick={() => follow(
            links.X.link, links.X.title, 'Follow'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Follow
          </Button>
        </Card.Text>
      </Card>


      {/* GitHub */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 0C3.58 0 0 3.58 0 8a8 8 0 0 0 5.47 7.59c.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82a7.6 7.6 0 0 1 2-.27c.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
          </svg>

          {links.GitHub.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.GitHub.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-light" onClick={() => follow(
            links.GitHub.link, links.GitHub.title, 'View'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            View
          </Button>
        </Card.Text>
      </Card>


      {/* LinkedIn */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#0A66C2" viewBox="0 0 24 24" style={{ marginRight: 9 }} > <path d="M20.447 20.452H16.89v-5.569c0-1.328-.024-3.037-1.852-3.037c-1.853 0-2.136 1.445-2.136 2.939v5.667H9.345V9h3.414v1.561h.049c.476-.9 1.637-1.85 3.37-1.85c3.601 0 4.269 2.37 4.269 5.455zM5.337 7.433a2.063 2.063 0 1 1 0-4.126a2.063 2.063 0 0 1 0 4.126zM7.119 20.452H3.555V9h3.564z" />
            {/* <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854z"/> */}
          </svg>

          {links.Linkedin.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.Linkedin.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-primary text-light" onClick={() => follow(
            links.Linkedin.link, links.Linkedin.title, 'Connect'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Connect
          </Button>
        </Card.Text>
      </Card>


      {/* Telegram */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#229ED9" viewBox="0 0 24 24" style={{ marginRight: 9 }} > <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12s12-5.373 12-12S18.627 0 12 0zm5.568 8.16l-1.97 9.294c-.148.658-.532.82-1.078.51l-2.98-2.197l-1.438 1.384c-.159.159-.293.293-.6.293l.213-3.054l5.56-5.022c.242-.213-.054-.333-.373-.12l-6.87 4.326l-2.96-.924c-.644-.203-.658-.644.135-.954l11.57-4.458c.538-.196 1.006.128.791 1.922z" /> </svg>
          {links.Telegram.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.Telegram.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-info text-light" onClick={() => follow(
            links.Telegram.link, links.Telegram.title, 'Join'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Join
          </Button>
        </Card.Text>
      </Card>




      {/* Hipi */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" > <defs> <linearGradient id="hipiGradient" x1="0%" y1="0%" x2="100%" y2="100%"> <stop offset="0%" stopColor="#FF0050" /> <stop offset="100%" stopColor="#7B61FF" /> </linearGradient> </defs> <path fill="url(#hipiGradient)" d="M7 3h3v7h4V3h3v18h-3v-8h-4v8H7z" /> </svg>

          {links.Hipi.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.Hipi.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-primary text-light" onClick={() => follow(
            links.Hipi.link, links.Hipi.title, 'Open'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Open
          </Button>
        </Card.Text>
      </Card>



      {/* WhatsApp */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="#25D366" > <path d="M19.11 17.2c-.29-.14-1.7-.84-1.96-.94c-.26-.1-.45-.14-.64.14c-.19.29-.74.94-.91 1.13c-.17.19-.33.22-.62.08c-.29-.14-1.22-.45-2.32-1.43c-.86-.77-1.44-1.72-1.61-2.01c-.17-.29-.02-.45.12-.59c.13-.13.29-.33.43-.5c.14-.17.19-.29.29-.48c.1-.19.05-.36-.02-.5c-.07-.14-.64-1.54-.88-2.11c-.23-.55-.47-.48-.64-.49h-.55c-.19 0-.5.07-.76.36c-.26.29-1 1-.99 2.44c0 1.43 1.03 2.81 1.17 3c.14.19 2.02 3.08 4.89 4.32c.68.29 1.21.46 1.62.59c.68.22 1.29.19 1.78.12c.54-.08 1.7-.69 1.94-1.35c.24-.67.24-1.24.17-1.36c-.07-.12-.26-.19-.55-.33z" /> <path d="M16 .4C7.39.4.4 7.39.4 16c0 3.02.86 5.97 2.49 8.51L.2 31.8l7.5-2.64A15.53 15.53 0 0 0 16 31.6c8.61 0 15.6-6.99 15.6-15.6S24.61.4 16 .4zm0 28.36c-2.54 0-5.03-.68-7.2-1.98l-.52-.31l-4.45 1.57l1.6-4.34l-.34-.54A12.72 12.72 0 0 1 3.28 16C3.28 8.96 8.96 3.28 16 3.28S28.72 8.96 28.72 16S23.04 28.76 16 28.76z" /> </svg>
          {links.WhatsApp.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.WhatsApp.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-success text-light" onClick={() => follow(
            links.WhatsApp.link, links.WhatsApp.title, 'Join'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Join
          </Button>
        </Card.Text>
      </Card>



      {/* Facebook */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#1877F2" viewBox="0 0 24 24">
            <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073c0 6.019 4.388 11.007 10.125 11.927v-8.437H7.078v-3.49h3.047V9.413c0-3.007 1.792-4.669 4.533-4.669c1.312 0 2.686.235 2.686.235v2.953h-1.513c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.08 24 18.092 24 12.073z" />
          </svg>

          {links.Facebook.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.Facebook.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-primary text-light" onClick={() => follow(
            links.Facebook.link, links.Facebook.title, 'Follow'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Follow
          </Button>
        </Card.Text>
      </Card>



      {/* Discord */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg style={{ marginRight: 9 }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#5865F2" viewBox="0 0 24 24">
            <path d="M20.317 4.369A19.791 19.791 0 0 0 15.885 3c-.191.328-.403.769-.552 1.116a18.27 18.27 0 0 0-5.336 0A11.64 11.64 0 0 0 9.445 3a19.736 19.736 0 0 0-4.433 1.369C2.216 8.552 1.457 12.63 1.8 16.65a19.9 19.9 0 0 0 5.993 3.03a14.87 14.87 0 0 0 1.284-2.106a12.92 12.92 0 0 1-2.024-.973c.17-.124.336-.255.496-.39c3.905 1.833 8.143 1.833 12.002 0c.161.135.327.266.496.39a12.89 12.89 0 0 1-2.028.974a14.77 14.77 0 0 0 1.285 2.105a19.86 19.86 0 0 0 5.995-3.03c.4-4.661-.684-8.703-3.982-12.281zM9.71 14.728c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.418 2.157-2.418c1.21 0 2.176 1.094 2.157 2.418c0 1.334-.956 2.419-2.157 2.419zm4.58 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.418 2.157-2.418c1.21 0 2.176 1.094 2.157 2.418c0 1.334-.947 2.419-2.157 2.419z" />
          </svg>

          {links.Discord.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.Discord.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-light" onClick={() => follow(
            links.Discord.link, links.Discord.title, 'Join'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Join
          </Button>
        </Card.Text>
      </Card>


      {/* ORCID */}

      <Card variant='dark' style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        <Card.Title style={{ display: 'block' }}>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 256 256"
          >
            <circle cx="128" cy="128" r="128" fill="#A6CE39" />
            <path fill="#fff" d="M86.5 74h20v108h-20z" />
            <circle cx="96.5" cy="52" r="12" fill="#fff" />
            <path fill="#fff" d="M125 95h31c28 0 44 18 44 43 0 26-17 44-44 44h-31zm20 18v51h11c15 0 24-9 24-25s-9-26-24-26z" />
          </svg>

          {links.ORCID.title}

        </Card.Title>

        <Card.Subtitle style={{ display: 'flexbox' }}>
          {links.ORCID.desc}
        </Card.Subtitle>

        <Card.Text variant='light' style={{ display: 'flex' }} >
          <Button variant="outline-light" onClick={() => follow(
            links.ORCID.link, links.ORCID.title, 'Join'
          )} style={{ margin: 20, textAlign: 'center', alignContent: 'center', display: 'flex' }}>
            Join
          </Button>
        </Card.Text>
      </Card>





      {/* Twitter <Card variant='dark' style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }} > <Card.Title> <i className="bi bi-twitter-x" style={{ marginRight: 9 }} ></i> {Twitter.title} </Card.Title> <Card.Subtitle> {Twitter.desc} </Card.Subtitle> <Card.Text> <Button variant="outline-light" onClick={() => follow( Twitter.link, Twitter.title, 'twitter' )} style={{ margin: 20 }} > Follow </Button> </Card.Text> </Card> */}


    </>
  )
}

export default Show;